import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { wagmiConfig } from './helper/wagmi';
import { ToastProvider } from 'react-toast-notifications';
import store from './redux/store';
import { Provider } from 'react-redux';
import './main.css';
import { BrowserRouter } from 'react-router-dom';


const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <ToastProvider placement="bottom-center" autoDismissTimeout={6000} autoDismiss>
            <BrowserRouter basename='/nft'>

              <App />

            </BrowserRouter>
          </ToastProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </Provider>
  </React.StrictMode>
);

